import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const Header = ({ isDarkMode, toggleDarkMode }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate("/");
    handleLinkClick();
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo" onClick={handleLogoClick}>
          Weber
        </div>
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </button>
        <nav className={`nav ${isMenuOpen ? "open" : ""}`}>
          <NavLink to="/" className="nav-item" onClick={handleLinkClick}>
            首页
          </NavLink>
          <NavLink
            to="/products"
            className="nav-item"
            onClick={handleLinkClick}
          >
            产品
          </NavLink>
          <NavLink to="/data" className="nav-item" onClick={handleLinkClick}>
            数据
          </NavLink>
          <NavLink to="/user" className="nav-item" onClick={handleLinkClick}>
            用户
          </NavLink>

          <NavLink to="/about" className="nav-item" onClick={handleLinkClick}>
            关于
          </NavLink>
          <NavLink
            to="/settings"
            className="nav-item"
            onClick={handleLinkClick}
          >
            设置
          </NavLink>
          <div
            className="dark-mode-toggle"
            onClick={() => {
              toggleDarkMode();
              handleLinkClick();
            }}
          >
            <div className={`toggle-icon ${isDarkMode ? "moon" : "sun"}`}>
              {isDarkMode ? "🌙" : "☀️"}
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
